const GAME_SPORT = {
	SOCCER:              'soccer',
	FUTSAL:              'futsal',
	HANDBALL:            'handball',
	TENNIS:              'tennis',
	SKI_ALPINE:          'ski_alpine',
	SKI_BIATHLON:        'ski_biathlon',
	SKI_CROSS:           'ski_cross',
	SKI_CROSS_COUNTRY:   'ski_cross_country',
	SKI_FREESTYLE:       'ski_freestyle',
	SKI_JUMPING:         'ski_jumping',
	SKI_MOGULS:          'ski_moguls',
	SKI_NORDIC_COMBINED: 'ski_nordic_combined',
	SKI_TELEMARK:        'ski_telemark',
	ICE_HOCKEY:          'ice_hockey',
	SNOWBOARD:           'snowboard',
	FLOORBALL:           'floorball',
	STREET_HOCKEY:       'street_hockey',
	ULTIMATE_FRISBEE:    'ultimate_frisbee',
	// TODO: to add more sports
};

// list of sports with sequential competition logic,
// where participants compete with each other sequentially, one after the other
export const SPORTS_SEQUENTIAL = [
	GAME_SPORT.SKI_ALPINE,
	GAME_SPORT.SKI_BIATHLON,
	GAME_SPORT.SKI_CROSS,
	GAME_SPORT.SKI_CROSS_COUNTRY,
	GAME_SPORT.SKI_JUMPING,
	GAME_SPORT.SKI_FREESTYLE,
	GAME_SPORT.SKI_JUMPING,
	GAME_SPORT.SKI_MOGULS,
	GAME_SPORT.SKI_NORDIC_COMBINED,
	GAME_SPORT.SKI_TELEMARK,
	GAME_SPORT.SNOWBOARD,
	// TODO: to add more sports
];

const SCOREBOARD_SUPPORTED_PARENT_CATEGORIES = ['match', 'competition'];

// note: event tag bulk edit and edit tag is disabled for clock tags on ice hockey and floorball
const GAME_CONTROL_SPORTS = [
	GAME_SPORT.SOCCER,
	GAME_SPORT.FUTSAL,
	GAME_SPORT.HANDBALL,
	GAME_SPORT.ICE_HOCKEY,
	GAME_SPORT.FLOORBALL,
	GAME_SPORT.STREET_HOCKEY,
	GAME_SPORT.ULTIMATE_FRISBEE,
];

export { GAME_SPORT, SCOREBOARD_SUPPORTED_PARENT_CATEGORIES, GAME_CONTROL_SPORTS };
